/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_BillingInputs */

const en_admin_nav_billing = /** @type {(inputs: Admin_Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments & Credits`)
};

/**
* | output |
* | --- |
* | "Payments & Credits" |
*
* @param {Admin_Nav_BillingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_billing = /** @type {((inputs?: Admin_Nav_BillingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_BillingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_billing(inputs)
});
export { admin_nav_billing as "admin.nav.billing" }